module.exports = __webpack_public_path__ + "fonts/Nunito-ExtraBoldItalic.0c32782.ttf";